var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-dialog',{attrs:{"title":_vm.title,"show-cancel-button":"","confirm-button-text":_vm.confirmButtonText,"confirm-button-color":"rgb(71, 118, 227)"},on:{"cancel":_vm.handleCancel,"confirm":_vm.handleConfirm},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}})
}
var staticRenderFns = []

export { render, staticRenderFns }